<template>
    <div>
        <app-login-component>
            <template slot="title">
                <div class="font-title-login">Willkommen bei iGroove.</div>
            </template>
            <template slot="password">
                <input type="password" class="font-input" placeholder="Passwort">
                <router-link to="/remember">
                    <div class="font-tiny">
                        Passwort vergessen?
                    </div>
                </router-link>
            </template>
            <template slot="btn">
                <router-link to="/neue">Anmelden</router-link>
            </template>
            <template slot="bottom-btn">
                <div class="font-size-btn bottom-btn">Account beantragen</div>
            </template>
        </app-login-component>
    </div>
</template>

<script>
  import LoginComponent from '../components/login/LoginComponent'

  export default {
    components: {
      appLoginComponent: LoginComponent
    }
  }
</script>

<style lang="scss" scoped>
    .font-tiny {
        padding-top: 8px;
        text-align: right;
        color: white;
    }
</style>
